import { s as makeRestApiRequest } from "./utils2.mjs";

//#region src/api/sso.ts
const initSSO = async (context, redirectUrl = "") => {
	return await makeRestApiRequest(context, "GET", `/sso/saml/initsso?redirect=${redirectUrl}`);
};
const getSamlMetadata = async (context) => {
	return await makeRestApiRequest(context, "GET", "/sso/saml/metadata");
};
const getSamlConfig = async (context) => {
	return await makeRestApiRequest(context, "GET", "/sso/saml/config");
};
const saveSamlConfig = async (context, data) => {
	return await makeRestApiRequest(context, "POST", "/sso/saml/config", data);
};
const toggleSamlConfig = async (context, data) => {
	return await makeRestApiRequest(context, "POST", "/sso/saml/config/toggle", data);
};
const testSamlConfig = async (context, data) => {
	return await makeRestApiRequest(context, "POST", "/sso/saml/config/test", data);
};
const getOidcConfig = async (context) => {
	return await makeRestApiRequest(context, "GET", "/sso/oidc/config");
};
const saveOidcConfig = async (context, data) => {
	return await makeRestApiRequest(context, "POST", "/sso/oidc/config", data);
};
const testOidcConfig = async (context) => {
	return await makeRestApiRequest(context, "POST", "/sso/oidc/config/test");
};
const initOidcLogin = async (context) => {
	return await makeRestApiRequest(context, "GET", "/sso/oidc/login");
};
const oidcLogout = async (context) => {
	return await makeRestApiRequest(context, "POST", "/sso/oidc/logout");
};

//#endregion
export { initSSO as a, saveSamlConfig as c, toggleSamlConfig as d, initOidcLogin as i, testOidcConfig as l, getSamlConfig as n, oidcLogout as o, getSamlMetadata as r, saveOidcConfig as s, getOidcConfig as t, testSamlConfig as u };
//# sourceMappingURL=sso.mjs.map